import { useCallback, useEffect, useState } from 'react';
import { getOperationalDashboard } from '../services';
import { IOperationalDashboardData, HookState } from '../types';
import { resolveErrorMessage } from './hookUtils';

export function useOperationalDashboard(options: {
	sellerId?: number;
	team?: string;
	enabled?: boolean;
}): HookState<IOperationalDashboardData> & { refetch: () => void } {
	const [state, setState] = useState<HookState<IOperationalDashboardData>>({
		data: null,
		loading: false,
		error: null,
		cachedAt: null,
	});
	const [fetchCount, setFetchCount] = useState(0);

	const sellerId = options.sellerId;
	const team = options.team;
	const enabled = options.enabled ?? true;

	useEffect(() => {
		if (!enabled || (!sellerId && !team)) return;

		let cancelled = false;
		setState((prev) => ({ ...prev, loading: true, error: null }));

		getOperationalDashboard({ sellerId, team })
			.then(({ data, cachedAt }) => {
				if (!cancelled) setState({ data, loading: false, error: null, cachedAt });
			})
			.catch((err) => {
				if (!cancelled) setState({ data: null, loading: false, error: resolveErrorMessage(err), cachedAt: null });
			});

		return () => {
			cancelled = true;
		};
	}, [sellerId, team, enabled, fetchCount]);

	const refetch = useCallback(() => setFetchCount((n) => n + 1), []);

	return { ...state, refetch };
}
